import styled from "styled-components";
import { mobile } from "styles/breakpoints";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 480px;
  width: 100%;
  position: relative;
`;

export const ModalHeader = styled.div`
  padding: 24px 24px 16px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a2e;
`;

export const ModalSubtitle = styled.p`
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 400;
  color: #6b6b76;
  line-height: 1.5;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #6b6b76;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: #f5f5f7;
    color: #1a1a2e;
  }

  &:focus {
    outline: 2px solid #798ecf;
    outline-offset: 2px;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SectionLabel = styled.p`
  margin: 0;
  padding: 0 24px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6b6b76;
`;

export const MethodList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
`;

export const MethodCard = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border: 1px solid #dedee3;
  border-radius: 10px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s, box-shadow 0.2s, background-color 0.15s;

  &:hover {
    border-color: #798ecf;
    box-shadow: 0 0 0 3px rgba(121, 142, 207, 0.15);
  }

  &:active {
    background-color: #f5f7ff;
  }

  &:focus {
    outline: 2px solid #798ecf;
    outline-offset: 2px;
  }
`;

export const MethodIcon = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #f0f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #5a6fb0;

  svg {
    width: 22px;
    height: 22px;
  }
`;

export const MethodLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #1a1a2e;
`;

export const ModalFooter = styled.div`
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${mobile}px) {
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const CancelButton = styled.button`
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #6b6b76;
  background: transparent;
  border: 1px solid #dedee3;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;

  &:hover {
    background: #f5f5f7;
    border-color: #c9c9d1;
  }

  &:focus {
    outline: 2px solid #798ecf;
    outline-offset: 2px;
  }
`;
